// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-fe33c3c2]{color:rgba(0,0,0,.7)}", ""]);
// Exports
module.exports = exports;
